export default "__VITE_ASSET__DRjwKiBO__"